import upperFirst from "lodash-es/upperFirst";

import { WikiArticleEntity } from "@/mk2/apps/wiki/schemas";
import { interpolate } from "@/mk2/services/i18n";
import {
    WIKI_REVIEW_TITLE_SUFFIX,
    count_WIKI_REVIEW_RATINGS,
} from "@/mk/autogenerated/translations/reviewSeoTitle.7df383cfc5ff47b87d5998086dddd203";

/**
 * SEO <title> body for a review product page (the " - Modrý koník" branding is
 * appended later in Page.tsx). Shape:
 *   "{name}: recenzie a skúsenosti[ {year}][ ({count} hodnotení)]"
 * The year (the latest review's year) is included only when the latest review is
 * recent — within the last 365 days; the count part is omitted when the product
 * has no reviews.
 */
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function buildReviewSeoTitle(article: WikiArticleEntity, now: Date): string {
    let title = upperFirst(article.title) + WIKI_REVIEW_TITLE_SUFFIX;

    const count = article.experiencesCount;
    if (count > 0) {
        const latest = article.latestExperienceCreatedAt;
        if (latest) {
            const latestDate = new Date(latest);
            const daysSinceLatest = (now.getTime() - latestDate.getTime()) / MS_PER_DAY;
            if (daysSinceLatest < 365) {
                title += ` ${latestDate.getFullYear()}`;
            }
        }
        title += ` (${interpolate(count_WIKI_REVIEW_RATINGS, { count })})`;
    }

    return title;
}
